import { Box, TextField, withStyles, InputAdornment } from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateFolderSearch } from "../../Stores/FolderAction/actions";
import SearchIcon from "@material-ui/icons/Search";

const StyledTextField = withStyles({
  root: {
    borderRadius: 30,
    width: 400,
    backgroundColor: "#f5f5f5",
    "& .MuiOutlinedInput-root": {
      paddingLeft: 10,
      paddingRight: 10,
      borderRadius: 30,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& input": {
      paddingLeft: 20,
    },
  },
})(TextField);

const PolicySearchCard = () => {
  const dispatch = useDispatch();
  const { folderSearch } = useSelector((state) => state.FolderActionReducer);

  const updateFilter = (value) => {
    dispatch(updateFolderSearch(value));
  };

  return (
    <Box>
      <StyledTextField
        variant="outlined"
        size="small"
        placeholder="Search folder, file"
        value={folderSearch}
        onChange={(e) => updateFilter(e?.target?.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default React.memo(PolicySearchCard);
